import {SELECT_CUSTOMER} from '../action-types';

export const initialState = {
  customerId: null,
};

export const customerSelectedReducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case SELECT_CUSTOMER:
      return {
        ...state,
        customerId: action.payload,
      };
    default:
      return state;
  }
};
